import { baseUrl, headers, jwtHeaders, logoutUtil } from '../common/data';

export const fetchAllBranch = async ({ limit, page }) => {
  const response = await fetch(`${baseUrl}/api/branch/getallbranches`, {
    method: 'GET',
    headers: jwtHeaders(),
    redirect: 'follow',
  });

  if (response?.status === 401) {
    logoutUtil();
  }
  const resData = await response?.json();

  return resData;
};

export const getBranch = async (branchId) => {
  const response = await fetch(`${baseUrl}/api/branch/getsinglebranch/${branchId}`, {
    method: 'GET',
    headers: headers,
  });
  const resData = await response?.json();

  return resData;
};

export const updateBranchStatus = async (data, id) => {
  const response = await fetch(`${baseUrl}/api/branch/updatestatus/${id}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
    redirect: 'follow',
  });
  const resData = await response?.json();

  return resData;
};

export const createBranch = async (data) => {
  try {
    const response = await fetch(`${baseUrl}/api/branch/createbranch`, {
      method: 'POST',
      body: data,
      headers: headers,
    });
    const resData = await response?.json();

    return resData;
  } catch (err) {}
};

export const deleteBranch = async (data) => {
  try {
    const response = await fetch(`${baseUrl}/api/branch/deletebranch/${data}`, {
      method: 'DELETE',
      headers: headers,
    });
    const resData = await response?.json();

    return resData;
  } catch (err) {}
};

export const updateBranchSubscription = async (data, id) => {
  const response = await fetch(`${baseUrl}/api/branch/updatebranchsubscription/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: headers,
  });
  const resData = response?.json();

  return resData;
};
